import { MarginProps, styledMargin } from '@tink/core/src/components/atoms/Margins/margins';
import { css, styled } from '../../../core/theme/styled';

type MutualHeaderStylesProps = MarginProps & {
  regularFontWeight?: boolean;
  align?: 'center';
  color?: 'primaryTextColor' | 'secondaryTextColor' | 'errorTextColor' | 'primaryColor';
};

const mutualHeaderStyles = css<MutualHeaderStylesProps>`
  ${styledMargin}

  color: ${({ theme, color }) =>
    color ? theme.configuration[color] : theme.configuration.primaryTextColor};
  font-weight: ${({ theme, regularFontWeight }) =>
    regularFontWeight ? theme.font.weights.regular : theme.font.weights.semiBold};
  ${({ align }) =>
    align &&
    `
    text-align: ${align};
  `}
`;

export const H1 = styled.h1<MutualHeaderStylesProps>`
  ${mutualHeaderStyles}
  font-size: ${(props) => props.theme.typography.h1.fontSize};
  line-height: ${(props) => props.theme.typography.h1.lineHeight};
`;

export const H2 = styled.h2<MutualHeaderStylesProps>`
  ${mutualHeaderStyles}
  font-size: ${(props) => props.theme.typography.h2.fontSize};
  line-height: ${(props) => props.theme.typography.h2.lineHeight};
`;

export const H3 = styled.h3<MutualHeaderStylesProps>`
  ${mutualHeaderStyles}
  font-size: ${(props) => props.theme.sizes.small};
  line-height: 1.25;
`;

export const H4 = styled.h4<MutualHeaderStylesProps>`
  ${mutualHeaderStyles}
  font-size: 13px;
  line-height: 1.25;
`;
